import WebModule from '../web_module'

export default class Content extends WebModule

  @selector: '.modulor_web_module_content'

# do not register since this is just superclass
